export const filterFontsByThemeFonts = (fonts, theme, defaultFontFamilies = []) => {
  const themeFonts = theme.getFonts();

  if (themeFonts.length === 0) {
    return fonts;
  }

  const result = {};

  for (const [key, value] of Object.entries(fonts)) {
    if (Array.isArray(value)) {
      const filteredArray = value.filter(
        item => themeFonts.includes(item) || defaultFontFamilies.includes(item)
      );

      if (filteredArray.length > 0) {
        result[key] = filteredArray;
      }
    } else {
      if (themeFonts.includes(key) || defaultFontFamilies.includes(key)) {
        result[key] = value;
      }
    }
  }

  return result;
}
